import { render, staticRenderFns } from "./FileBadge.vue?vue&type=template&id=69a73b8d"
import script from "./FileBadge.vue?vue&type=script&lang=js"
export * from "./FileBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports